export const pushToDataLayer = (event: DatalayerEvent) => {
	window.dataLayer = window.dataLayer || []
	window.dataLayer.push(event)
}
